import { useEffectOnce } from 'react-use';
import { JobsPanel } from '../../components/JobsPanel';
import { resetStore, useLayoutDispatch } from '../../redux';

const Jobs: React.FC = () => {
	const dispatch = useLayoutDispatch();

	useEffectOnce(() => {
		return () => {
			dispatch(resetStore());
		};
	});

	return <JobsPanel />;
};

export { Jobs };
